import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import * as styles from './styles.module.scss';

const FooterDisclaimer = (props) => {
  const { customFooterDisclaimer } = props;

  const {
    prismicSettings: { data },
  } = useStaticQuery(settingsQuery);

  const { footer_disclaimer: footerDisclaimer } = data;

  const footerHtmlToUse = customFooterDisclaimer?.html || footerDisclaimer?.html;

  return (
    footerHtmlToUse && <div dangerouslySetInnerHTML={{ __html: footerHtmlToUse }} className={styles.footerDisclaimer} />
  );
};

export default FooterDisclaimer;

export const settingsQuery = graphql`
  query FooterDisclaimer {
    prismicSettings {
      data {
        footer_disclaimer {
          text
          html
        }
      }
    }
  }
`;
